import "./PipelineTable.scss";
import Component from "./PipelineTable.js";
export default Component;